import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<nav class={{this.classNames}} aria-label={{this.ariaLabel}} ...attributes>\n  {{yield}}\n</nav>", {
  moduleName: "@1024pix/pix-ui/components/pix-tabs.hbs"
});